<template>
  <v-multiselect
    :options="options"
    v-model="selected"
    :allow-empty="false"
  />
</template>
<script>
  import { range } from 'lodash'

  export default {
    props: ['value'],
    data () {
      return {
        selected: this.value,
      }
    },
    computed: {
      options () {
        return range(-12, 13).map((gmt) => {
          return (gmt < 0 ? '-' : '+') + ('0' + Math.abs(gmt)).slice(-2) + ':00'
        })
      },
    },
    watch: {
      selected (nv, ov) {
        if (nv !== ov) {
          this.$emit('input', this.selected)
        }
      },
      value () {
        this.selected = this.value
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/gmt-select.vue